import {config} from '../config';

export default {
    getIsBenefitPageEnabled: () => config.data.benefitPage.isBenefitPageEnabled,
    getСustomBenefit: () => config.data.benefitPage.benefitSections,
    getBenefitImageSrc: () => config.data.benefitPage.imageSrc,
};
